import Links from '../data/Links';
import { Link } from 'react-router-dom';
import React from 'react';
import Util from '../util';

const BrandLogo = ({ onClick }) => (
	<Link to={Links.DASHBOARD} className="brand-logo" onClick={onClick}>
		{Util.BRAND_NAME}
	</Link>
);

export default BrandLogo;
